const initializeSwiper = () => {
	const screenWidth = window.innerWidth

	document.querySelectorAll('.wp-block-handpicked-products').forEach(el => {
		const menuAdded = el.querySelector('.swiper-nav-wrapper')
		if (screenWidth <= 992) {
			if (!el.swiper && !el.querySelector('.swiper-nav-wrapper')) {
				if (!menuAdded) {
					const tempDiv = document.createElement('div')
					tempDiv.className = 'swiper-nav-wrapper'
					tempDiv.innerHTML = swiperHTML
					el.appendChild(tempDiv)

					el.swiper = new Swiper(el, {
						slideClass: 'product',
						// slidesPerView: 3,
						spaceBetween: 10,
						lazy: true,
						navigation: {
							nextEl: el.querySelector('.swiper-button-next'),
							prevEl: el.querySelector('.swiper-button-prev')
						},
						pagination: {
							el: el.querySelector('.swiper-pagination'),
							clickable: true
						},
						// pagination: { el: '.swiper-pagination', type: 'bullets', clickable: true },
						// navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
						breakpoints: {
							320: { slidesPerView: 1 },
							768: { slidesPerView: 2 },
							992: { slidesPerView: 3 }
						}
					})
				}
			}
		} else {
			if (el.swiper) {
				el.swiper.destroy()
				el.swiper = null
			}

			// Remove the swiper-nav-wrapper when the screen size goes above 768px
			if (menuAdded) {
				menuAdded.remove()
			}
		}
	})
	
	const selfChosenProds = Array.from(document.querySelectorAll('.self-chosen-prods'))

	if (selfChosenProds.length > 0) {
		selfChosenProds.forEach(el => {
			if (!el.swiper && !el.querySelector('.swiper-nav-wrapper')) {
				const tempDiv = document.createElement('div')
				tempDiv.className = 'swiper-nav-wrapper'
				tempDiv.innerHTML = swiperHTML
				el.appendChild(tempDiv)

				el.swiper = new Swiper(el, {
					spaceBetween: 16,
					lazy: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					breakpoints: {
						576: { slidesPerView: 1.5 },
						768: { slidesPerView: 2.5 },
						1200: { slidesPerView: 3 }
					}
				})
			}
		})
	}

	if (document.body.classList.contains('single-product') || document.body.classList.contains('woocommerce-cart') ) {
		document.querySelectorAll('.pdp__bottom__left > .more-products__wrap').forEach(el => {
			const slides = el.querySelectorAll('.swiper-slide');
			const menuAdded = el.querySelector('.swiper-nav-wrapper');
	
			if (screenWidth <= 991) {
				if (!el.swiper && !el.querySelector('.swiper-nav-wrapper')) {
					if (!menuAdded) {
						if( slides.length > 2 ) {
							const tempDiv = document.createElement('div');
							tempDiv.className = 'swiper-nav-wrapper';
							tempDiv.innerHTML = swiperHTML;
							el.appendChild(tempDiv);
						}
	
						el.swiper = new Swiper(el, {
							// ...swiperOptions,
							slidesPerView: 2,
							spaceBetween: 10,
							lazy: true,
							pagination: { el: '.swiper-pagination', type: 'bullets', clickable: true },
							navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
							breakpoints: {
								480: { slidesPerView: 2 },
								768: { slidesPerView: 3 }
							}
						});
					}
				}
			} else {
				if (el.swiper) {
					el.swiper.destroy()
					el.swiper = null
				}
	
				if (menuAdded) {
					menuAdded.remove();
				}
			}
		});
		
		document.querySelectorAll('.last-viewed__wrap').forEach(el => {
			const slides = el.querySelectorAll('.swiper-slide');
			const menuAdded = el.querySelector('.swiper-nav-wrapper')
			if (screenWidth <= 992 && slides.length > 2) {
				if (!el.swiper && !el.querySelector('.swiper-nav-wrapper')) {
					if (!menuAdded) {
						const tempDiv = document.createElement('div')
						tempDiv.className = 'swiper-nav-wrapper'
						tempDiv.innerHTML = swiperHTML
						el.appendChild(tempDiv)

						el.swiper = new Swiper(el, {
							...swiperOptions,
							slidesPerView: 2,
							spaceBetween: 10,
							lazy: true,
							pagination: { el: '.swiper-pagination', type: 'bullets', clickable: true },
							navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
							breakpoints: {
								480: { slidesPerView: 2 },
								768: { slidesPerView: 3 }
							}
						})
					}
				}
			} else {
				if (el.swiper) {
					el.swiper.destroy()
					el.swiper = null
				}

				// Remove the swiper-nav-wrapper when the screen size goes above 768px
				if (menuAdded) {
					menuAdded.remove()
				}
			}
		})
	}

	const reviewSliders = Array.from(document.querySelectorAll('.review-swiper'))

	if (reviewSliders.length > 0) {
		reviewSliders.forEach(el => {
			if (!el.swiper && !el.querySelector('.swiper-nav-wrapper')) {
				const tempDiv = document.createElement('div')
				tempDiv.className = 'swiper-nav-wrapper'
				tempDiv.innerHTML = swiperHTML
				el.appendChild(tempDiv)

				el.swiper = new Swiper(el, {
					spaceBetween: 16,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					breakpoints: {
						768: { slidesPerView: 2 },
						992: { slidesPerView: 3 },
						1200: { slidesPerView: 4 }
					}
				})
			}
		})
	}
	
	const postAdviceSliders = Array.from(document.querySelectorAll('.post-advice-slider'))

	if (postAdviceSliders.length > 0) {
		postAdviceSliders.forEach(el => {
			if (!el.swiper && !el.querySelector('.swiper-nav-wrapper')) {
				const tempDiv = document.createElement('div')
				tempDiv.className = 'swiper-nav-wrapper'
				tempDiv.innerHTML = swiperHTML
				el.appendChild(tempDiv)

				el.swiper = new Swiper(el, {
					spaceBetween: 16,
					lazy: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					breakpoints: {
						576: { slidesPerView: 1.5 },
						768: { slidesPerView: 2.5 },
						1200: { slidesPerView: 3 }
					}
				})
			}
		})
	}
	
    const categoryCardSlider = Array.from(document.querySelectorAll('.category-card-slider'))

	if (categoryCardSlider.length > 0) {
		categoryCardSlider.forEach(el => {
			if (!el.swiper && !el.querySelector('.swiper-nav-wrapper')) {
				const tempDiv = document.createElement('div')
				tempDiv.className = 'swiper-nav-wrapper'
				tempDiv.innerHTML = swiperHTML
				el.appendChild(tempDiv)

				el.swiper = new Swiper(el, {
					slidesPerView: 2,
					spaceBetween: 16,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					breakpoints: {
						400: { slidesPerView: 3 },
						600: { slidesPerView: 4 },
						800: { slidesPerView: 5 },
						992: { slidesPerView: 6 },
						1200: { slidesPerView: 8 }
					}
				})
			}
		})
	}
    
    const advantagesCardSlider = Array.from(document.querySelectorAll('.advantages-card-slider'))

	if (advantagesCardSlider.length > 0) {
		advantagesCardSlider.forEach(el => {
			if (!el.swiper && !el.querySelector('.swiper-nav-wrapper')) {
				const tempDiv = document.createElement('div')
				tempDiv.className = 'swiper-nav-wrapper'
				tempDiv.innerHTML = swiperHTML
				el.appendChild(tempDiv)

				el.swiper = new Swiper(el, {
					slidesPerView: 1.5,
					spaceBetween: 16,
					lazy: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					breakpoints: {
						400: { slidesPerView: 2 },
                        650: { slidesPerView: 2.5 },
                        768: { slidesPerView: 3.5 },
                        992: { slidesPerView: 4.5 },
					}
				})
			}
		})
	}
}

let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initializeSwiper, 200);
});

const swiperHTML = `
    <div class="swiper-nav">
        <div class="swiper-pagination"></div>
        <div class="swiper-buttons">
            <div class="swiper-button-prev"><svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.86103 12.4352L24.8697 12.4353C25.1694 12.4353 25.4569 12.3162 25.6689 12.1042C25.8809 11.8922 26 11.6047 26 11.3049C26 11.0051 25.8809 10.7176 25.6689 10.5056C25.4569 10.2936 25.1694 10.1746 24.8697 10.1746L3.86103 10.1746L12.1058 1.93207C12.318 1.71982 12.4373 1.43195 12.4373 1.13178C12.4373 0.831615 12.318 0.543744 12.1058 0.331495C11.8935 0.119246 11.6057 6.21947e-06 11.3055 6.19323e-06C11.0053 6.16699e-06 10.7175 0.119246 10.5052 0.331494L0.332084 10.5046C0.226818 10.6096 0.143303 10.7344 0.0863186 10.8717C0.0293345 11.009 2.29346e-06 11.1562 2.28046e-06 11.3049C2.26746e-06 11.4536 0.0293344 11.6008 0.0863185 11.7381C0.143303 11.8755 0.226818 12.0002 0.332083 12.1052L10.5052 22.2783C10.7175 22.4906 11.0053 22.6098 11.3055 22.6098C11.6057 22.6098 11.8935 22.4906 12.1058 22.2783C12.318 22.0661 12.4373 21.7782 12.4373 21.478C12.4373 21.1779 12.318 20.89 12.1058 20.6777L3.86103 12.4352Z" fill="currentColor"/></svg></div>
            <div class="swiper-button-next"><svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.139 10.1746L1.13035 10.1746C0.83056 10.1746 0.543052 10.2937 0.331071 10.5057C0.11909 10.7177 0 11.0052 0 11.305C0 11.6047 0.11909 11.8923 0.331071 12.1042C0.543052 12.3162 0.83056 12.4353 1.13035 12.4353L22.139 12.4353L13.8942 20.6778C13.682 20.89 13.5627 21.1779 13.5627 21.4781C13.5627 21.7782 13.682 22.0661 13.8942 22.2784C14.1065 22.4906 14.3943 22.6099 14.6945 22.6099C14.9947 22.6099 15.2825 22.4906 15.4948 22.2784L25.6679 12.1052C25.7732 12.0002 25.8567 11.8755 25.9137 11.7382C25.9707 11.6009 26 11.4536 26 11.305C26 11.1563 25.9707 11.0091 25.9137 10.8717C25.8567 10.7344 25.7732 10.6097 25.6679 10.5047L15.4948 0.33155C15.2825 0.119301 14.9947 6.10352e-05 14.6945 6.10352e-05C14.3943 6.10352e-05 14.1065 0.119301 13.8942 0.33155C13.682 0.543799 13.5627 0.83167 13.5627 1.13184C13.5627 1.432 13.682 1.71987 13.8942 1.93212L22.139 10.1746Z" fill="currentColor"/></svg></div>
        </div>
    </div>`

const swiperOptions = {
	slidesPerView: 1,
	breakpoints: {
		768: {
			initialSlide: 1,
			centeredSlides: true,
			slidesPerView: 2.5,
			spaceBetween: 40
		},
		992: {
			initialSlide: 1,
			centeredSlides: true,
			slidesPerView: 2.5,
			spaceBetween: 80
		}
	}
}

window.addEventListener('DOMContentLoaded', () => {
	if (typeof Swiper === 'undefined') {
		return
	}

	initializeSwiper()

	window.addEventListener('resize', initializeSwiper)
})

$(document.body).on('updated_cart_totals', function () {
	initializeSwiper()
})

if (document.body.classList.contains('single-product')) {
    const thumbSwiper = document.querySelector('.swiper-thumbs');
    const mainSwiper = document.querySelector('.swiper-main');
    const thumbSlides = thumbSwiper.querySelectorAll('.swiper-slide');
    const mainSlides = mainSwiper.querySelectorAll('.swiper-slide');
    let topSwiper;
    let productThumbsSwiper;

    function initSwiper() {
        topSwiper = new Swiper(".swiper-main", {
            grabCursor: true,
            effect: 'slide',
            slidesPerView: 'auto',
            loop: false,
            watchSlidesProgress: true,
            autoScrollOffset: 1,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }

    initSwiper();

    if (window.innerWidth >= 768 && thumbSlides.length > 1 && mainSlides.length > 1) {
        if (!thumbSwiper.swiper) {
            productThumbsSwiper = new Swiper(".swiper-thumbs", {
                loop: false,
                grabCursor: true,
                spaceBetween: 10,
                slidesPerView: 2,
                watchSlidesProgress: true,
                direction: 'vertical',
            });

            mainSwiper.swiper.thumbs.swiper = productThumbsSwiper;
            mainSwiper.swiper.thumbs.init();
        }
    } else {
        if (thumbSwiper.swiper) {
            thumbSwiper.swiper.destroy();
            thumbSwiper.swiper = null;
        }
    }

    // Assign the Swiper instances to the global window object for the variation buttons to use
    window.topSwiper = topSwiper;
    window.productThumbsSwiper = productThumbsSwiper;
}